const base = 'https://drive.google.com/thumbnail?id=';

const KnownPlayers = [
  {
    name: 'Heartoast',
    imageLink: base + '1EnZB01KMLHDXO2sLVryfBEwm5-I49BgJ',
  },
  {
    name: 'default',
    imageLink: 'res/default_pfp.png',
  },
];

export default KnownPlayers;
